import { type GoogleSignInHostProps } from '../constants/auth'

export function AuthGoogleHost({ hostRef }: GoogleSignInHostProps) {
  return <div ref={hostRef} className="auth-google-host" />
}
